import { Component, HostBinding, OnInit, AfterViewInit } from '@angular/core';
import { environment } from 'environments/environment';
import { ToasterConfig } from 'angular2-toaster';

declare var $: any;
import { AuthService, UserService,GoogleAnalyticsService } from './shared/services';
import { SettingsService } from './core/settings/settings.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit,AfterViewInit {
    isprod: boolean = false;
    toasterconfig: ToasterConfig = new ToasterConfig({
        positionClass: 'toast-bottom-right',
        showCloseButton: true
    });
    @HostBinding('class.layout-fixed') get isFixed() { return this.settings.layout.isFixed; };
    @HostBinding('class.aside-collapsed') get isCollapsed() { return this.settings.layout.isCollapsed; };
    @HostBinding('class.layout-boxed') get isBoxed() { return this.settings.layout.isBoxed; };
    @HostBinding('class.layout-fs') get useFullLayout() { return this.settings.layout.useFullLayout; };
    @HostBinding('class.hidden-footer') get hiddenFooter() { return this.settings.layout.hiddenFooter; };
    @HostBinding('class.layout-h') get horizontal() { return this.settings.layout.horizontal; };
    @HostBinding('class.aside-float') get isFloat() { return this.settings.layout.isFloat; };
    @HostBinding('class.offsidebar-open') get offsidebarOpen() { return this.settings.layout.offsidebarOpen; };
    @HostBinding('class.aside-toggled') get asideToggled() { return this.settings.layout.asideToggled; };
    @HostBinding('class.aside-collapsed-text') get isCollapsedText() { return this.settings.layout.isCollapsedText; };

    constructor(
        public settings: SettingsService,
        private authService: AuthService,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.isprod = environment.production;
        this.appendGaTrackingCode();
    }

    ngOnInit() {
        this.authService.init();
        $(document).on('click', '[href="#"]', e => e.preventDefault());
    }

    ngAfterViewInit() {
        $( window ).scroll( function() {
          if ( $( this ).scrollTop() > 100 ) {              
            $( '.back-to-top' ).addClass( 'show-back-to-top' );
          } else {
            $( '.back-to-top' ).removeClass( 'show-back-to-top' );
          } 
        });

        $(document).ready(function() {
          $( '.back-to-top' ).click( function() {
            $( 'html, body' ).animate( { scrollTop : 0 }, 800 );
            return false;
          });
        });
    }

    private appendGaTrackingCode() {
    try {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

                ga('create', '` + environment.googleAnalytics.trackingId + `', '` + environment.googleAnalytics.domain + `');
                ga('require', 'ec');
      `;
      document.head.appendChild(script);
    } catch (ex) {
     console.error('Error appending google analytics');
     console.error(ex);
    }
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.component.ts